import { useQuery } from '@tanstack/react-query'
import { api } from '../../api'

export const checkoutInfoQueryKey = 'checkout-info'

export const checkoutInfoQuery = (session: string) => ({
  queryKey: ['checkout-info'],
  queryFn: () => api.getCheckoutInfo(session),
})

export const useCheckoutInfo = (session: string) =>
  useQuery(checkoutInfoQuery(session))
